import { useEffect, useState } from "react";
import { groupFundsByType } from "components/base/TableFunds/groupFundsByType";
import { Fund, UseFunds } from "components/base/TableFunds/types";
import { FUNDS_PATH } from "lib/constants";
import { getURLToFetch } from "lib/utils";

const useFunds = () => {
  const [fundsResponse, setFundsResponse] = useState<UseFunds>({ error: false, loading: true });

  useEffect(() => {
    fetch(getURLToFetch(FUNDS_PATH), {
      method: "POST",
    })
      .then((res) => res.json())
      .then((funds: Fund[]) => {
        const groupedFunds = groupFundsByType(funds);

        setFundsResponse({ ...fundsResponse, funds: groupedFunds, loading: false });
      })
      .catch((error) => {
        setFundsResponse({ error, loading: false });
        console.error(error, "error");
      });
  }, []);

  return { ...fundsResponse };
};

export { useFunds };
